<template>
  <div>
    <h2>Usuários</h2>

    <v-data-table
      :headers="headers"
      :items="data"
      :page.sync="page"
      :sort-by.sync="sortBy"
      :items-per-page="perPage"
      :loading="isLoading"
      hide-default-footer
      disable-sort
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field 
            v-model="searchFilter.query"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>

          <v-dialog
            v-model="dialogForm"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }" v-if="permissions['create_users']">
              <v-btn
                outlined
                color="#0dc4b8" 
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >Novo Usuário</v-btn>
            </template>
            <UserForm v-if="dialogForm" v-on:onClose="closeFormModal" v-on:onSubmit="closeFormModal();loadData()" />
          </v-dialog>

          <v-dialog
            v-model="dialogUserRolesForm"
            max-width="500px"
          >
            <UserRolesForm :selectedItem="selectedItem" v-on:onClose="closeUserRolesFormModal" v-on:onSubmit="closeUserRolesFormModal();loadData()" />
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.roles="{ item }">
        {{ item.roles | formatList }}
      </template>

      <template v-slot:item.is_active="{ item }">
        {{ item.is_active ? 'Ativo' : 'Inativo' }}
      </template>

      <template v-slot:item.actions="{ item }" v-if="permissions['edit_users']">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="openEditUserRoleModal(item)"
              v-bind="attrs"
              v-on="on"
            >mdi-account-group</v-icon>
          </template>
          <span>Editar Perfil de Acesso</span>
        </v-tooltip>
        <v-tooltip bottom v-if="item.is_active">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="changeStatus(item)"
              v-bind="attrs"
              v-on="on"
              :disabled="user.id == item.id"
            >mdi-account-cancel</v-icon>
          </template>
          <span>Inativar Usuário</span>
        </v-tooltip>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              class="mr-2"
              @click="changeStatus(item)"
              v-bind="attrs"
              v-on="on"
            >mdi-account-check</v-icon>
          </template>
          <span>Ativar Usuário</span>
        </v-tooltip>
      </template>

      <template v-slot:footer>
        <div class="table-footer">
          <span class="mr-4" v-if="total>0">Exibindo {{from}} - {{to}} de {{total}} </span>
        </div>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="totalPages"
      ></v-pagination>
    </div>

  </div>
</template>


<script>
import { mapGetters, mapMutations } from 'vuex';
import UsersService from '../../services/users.service';
import UserForm from './_form.vue';
import UserRolesForm from './_roles_form.vue';

export default {
  name: 'Users',
  components: {
    UserForm,
    UserRolesForm
  },
  data: () => ({
    data: [],
    dialogForm: false,
    dialogUserRolesForm: false,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Nome', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Perfil de Acesso', value: 'roles' },
      { text: 'Status', value: 'is_active' },
    ],
    isLoading: true,
    page: 1,
    perPage: 10,
    searchFilter: {
      query: null,
    },
    selectedIndex: -1,
    selectedItem: {
        email: null,
        is_active: false,
        name: null,
        password: null,
        password_confirmation: null,
        show_password: false,
        show_password_confirmation: false,
        roles: [],
    },
    sortBy: 'id',
    to: 0,
    total: 0,
    totalPages: 0,
  }),
  computed: {
    ...mapGetters(['permissions', 'user']),
  },
  filters: {
    formatList(list) {
      return list.map(e => e.name).sort().join(', ') 
    }
  },
  watch: {
    dialogForm (val) {
      if (val && this.selectedIndex == -1 && this.$refs.form)
        this.$refs.form.resetValidation();
      val || this.closeFormModal()
    },
    page: function () {
      this.loadData();
    },
    searchFilter: {
      handler () {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.permissions['edit_users'] || this.permissions['delete_users']) {
      this.headers.push({ text: 'Ações', value: 'actions', sortable: false });
    }

    this.loadData();
  },
  methods: {
    ...mapMutations(["showSnackbar"]),

    changeStatus (item) {
      let selectedIndex = this.data.indexOf(item);
      this.isLoading = true;
      UsersService.changeStatus({'is_active': !item.is_active}, item.id)
        .then(() => {
          this.data[selectedIndex].is_active = !item.is_active;

          if (!item.is_active) 
            this.showSnackbar({ text: "Usuário inativado com sucesso!", color:"success" })
          else
            this.showSnackbar({ text: "Usuário ativado com sucesso!", color:"success" })
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => { this.isLoading = false; }, 300));
    },

    clearForm () {
      this.selectedItem = {
        email: null,
        is_active: false,
        name: null,
        password: null,
        password_confirmation: null,
        show_password: false,
        show_password_confirmation: false,
        roles: [],
      };
      this.selectedIndex = -1;
    },

    closeFormModal () {
      this.dialogForm = false;
      this.$nextTick(() => {
        this.clearForm();
      })
    },

    closeUserRolesFormModal () {
      this.dialogUserRolesForm = false;
      this.$nextTick(() => {
        this.clearForm();
      })
    },

    loadData () {
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
      };

      if (this.searchFilter.query) 
        params['filter[nameOrEmail]'] = this.searchFilter.query;

      params['filter[notClient]'] = true;

      UsersService.get(params)
        .then(({ data }) => {
          const { from, to, total, data: items, current_page } = data;
          this.data = items;
          this.page = current_page;
          this.from = from;
          this.to = to;
          this.total = total;
          this.totalPages = Math.ceil(this.total/this.perPage);
        })
        .catch(() => { this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" }) })
        .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    openEditUserRoleModal (item) {
      this.selectedIndex = this.data.indexOf(item);
      this.selectedItem = Object.assign({}, item);
      this.dialogUserRolesForm = true;
    },
  },
}
</script>
